import React from 'react';

const AppMetricsTableSkeleton: React.FC = () => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm p-6 border border-gray-100 dark:border-gray-700 relative overflow-hidden">
      <div className="mb-4">
        <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-2 shimmer"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2 shimmer"></div>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="bg-gray-50 dark:bg-gray-700">
              {Array.from({ length: 7 }).map((_, i) => (
                <th key={i} className="px-4 py-3 border border-gray-200 dark:border-gray-600">
                  <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-20 shimmer"></div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 10 }).map((_, rowIndex) => (
              <tr key={rowIndex}>
                {Array.from({ length: 7 }).map((_, colIndex) => (
                  <td key={colIndex} className="px-4 py-3 border border-gray-200 dark:border-gray-600">
                    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-16 shimmer"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }
        
        .shimmer {
          background: linear-gradient(
            90deg,
            #f0f0f0 0%,
            #e0e0e0 20%,
            #f0f0f0 40%,
            #f0f0f0 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite linear;
        }
        
        .dark .shimmer {
          background: linear-gradient(
            90deg,
            #374151 0%,
            #4b5563 20%,
            #374151 40%,
            #374151 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite linear;
        }
      `}</style>
    </div>
  );
};

export default AppMetricsTableSkeleton;

